import UserNotification from "util/UserNotification";
import { setIsNew, setIsDirty } from "views/logic/slices/viewSlice";
import { updateView } from "views/api/views";
const _extractErrorMessage = (error) => error && error.additional && error.additional.body && error.additional.body.message ? error.additional.body.message : error;
export default (view, entityShare) => async (dispatch) => {
  try {
    await updateView(view, entityShare);
    dispatch(setIsNew(false));
    dispatch(setIsDirty(false));
    UserNotification.success(`Saving view "${view.title}" was successful!`, "Success!");
  } catch (error) {
    UserNotification.error(`Saving view failed: ${_extractErrorMessage(error)}`, "Error!");
  }
};
